import { getDealRevenue } from '../../../../shared/utils/dealRevenue';
import React, { lazy, Suspense, useState } from 'react';
import EntityLinkButton from '../../../../shared/components/linked-entities/EntityLinkButton';
import EntityDetailDialog from '../../../../shared/components/EntityDetailDialog';
import { useLinkedEntityCards } from '../../../../shared/components/linked-entities/LinkedEntityCardHost';
import { listDealPayments } from '../../../accounting/services/deal-accounting-links';
const DealAccountingSection = lazy(() => import('./DealAccountingSection'));

export default function DealIncomeLink({ deal, completed = false }) {
  const { openEntityCard } = useLinkedEntityCards();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  return <>
    <EntityLinkButton disabled={loading} aria-label={`Apri incassi di ${deal.name}`} onClick={async () => {
      setLoading(true);
      try {
        const rows = await listDealPayments(deal.id, completed);
        if (rows.length === 1) openEntityCard({ entityType: 'payment', entityId: rows[0].id });
        else setOpen(true);
      } catch { setOpen(true); }
      finally { setLoading(false); }
    }}><span className="entity-link-button__content"><span>{loading ? 'Caricamento…' : 'Incassi'}</span>
      <strong>{getDealRevenue(deal).toLocaleString('it-IT', { style: 'currency', currency: 'EUR' })}</strong></span></EntityLinkButton>
    {open ? <EntityDetailDialog isOpen title="Incassi dell’affare" subtitle={deal.name} onClose={() => setOpen(false)}>
      <Suspense fallback={<p role="status">Caricamento incassi…</p>}><DealAccountingSection deal={deal} dealType={completed ? 'completato' : 'inCorso'} /></Suspense>
    </EntityDetailDialog> : null}
  </>;
}
